<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <h1 class="title">Manage Scenario Type List</h1>

  <div class="extra-buttons">
    <button id="update-button" mat-raised-button color="primary" class="action-button"
            [disabled]="selectedValue===''"
            (click)="updateValue()">
      Update
    </button>
    <button id="add-button" mat-flat-button color="primary" class="action-button"
            (click)="addValue()">
      Add
    </button>
    <button id="delete-button" mat-raised-button color="warn" class="action-button"
            [disabled]="selectedValue===''"
            (click)="deleteValue()">
      Delete
    </button>
  </div>
</div>

<div class="gfs-table">

  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="scenarioTypes"
    [columnDefs]="columnHeaders"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>
